module.exports = __webpack_public_path__ + "static/media/masteryi.d934df79.png";